(function ($) {
	"use_strict";

	if (!$('.supporting-articles-toggle')) {
		return false;
	}

	$('body').on('click', '.supporting-articles-toggle', function(e) {
		e.preventDefault();
		$(this).parents('.user-journey__info-supporting-articles').toggleClass('open').find('.user-journey__info-supporting-articles-list').slideToggle();
	});

}(jQuery));